/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ai_Support_TitleInputs */

const et_service_ai_support_title = /** @type {(inputs: Service_Ai_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI klienditugi - vestlusrobot ja kõneadministraator`)
};

const en_service_ai_support_title = /** @type {(inputs: Service_Ai_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Customer Support - Chatbot & Voice Admin`)
};

/**
* | output |
* | --- |
* | "AI Customer Support - Chatbot & Voice Admin" |
*
* @param {Service_Ai_Support_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_ai_support_title = /** @type {((inputs?: Service_Ai_Support_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ai_Support_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_ai_support_title(inputs)
	return en_service_ai_support_title(inputs)
});